var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIpReverseImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: 2,
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.7,
    clipPath: "url(#clip0_4872_39438)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.26514 5.00073H15.0981V6.66738H4.26514V5.00073Z",
    fill: "url(#paint0_linear_4872_39438)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.26514 8.33398H15.0981V10.0006H4.26514V8.33398Z",
    fill: "url(#paint1_linear_4872_39438)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.26514 11.6675H11.7648V13.3341H4.26514V11.6675Z",
    fill: "url(#paint2_linear_4872_39438)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.26514 15.0002H11.7648V16.6669H4.26514V15.0002Z",
    fill: "url(#paint3_linear_4872_39438)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M0.0996094 48.3335H50.0989V50.0001H0.0996094V48.3335Z",
    fill: "url(#paint4_linear_4872_39438)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M43.0535 6.81252L44.3986 2.96921L46.8499 7.87338C47.0559 8.28499 47.5564 8.45246 47.9683 8.24646C48.3803 8.04085 48.5474 7.53998 48.3418 7.12837L45.0085 0.461808C44.8029 0.0498203 44.3024 -0.117263 43.8908 0.0879674C43.8904 0.0883489 43.8904 0.0883489 43.8901 0.0883489L37.2235 3.42163C36.8119 3.62763 36.6444 4.12811 36.8504 4.5401C37.056 4.95171 37.5569 5.11917 37.9685 4.91318L42.7968 2.50076L41.4795 6.26244C35.6884 22.7545 20.773 34.3249 3.35889 35.8336L3.50079 37.5002C21.571 35.9351 37.0476 23.9272 43.0535 6.81252Z",
    fill: "url(#paint5_linear_4872_39438)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M4.26613 40C3.80569 40 3.43262 40.3731 3.43262 40.8335V45.8335C3.43262 46.2935 3.80569 46.6666 4.26613 46.6666H10.0992C10.5596 46.6666 10.9327 46.2935 10.9327 45.8335V40.8335C10.9327 40.3731 10.5596 40 10.0992 40H4.26613ZM9.26605 44.9999H5.09926V41.6666H9.26605V44.9999Z",
    fill: "url(#paint6_linear_4872_39438)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M13.4331 37.5C12.9731 37.5 12.5996 37.8731 12.5996 38.3335V45.8336C12.5996 46.2936 12.9727 46.6667 13.4331 46.6667H19.2666C19.7266 46.6667 20.0997 46.2936 20.0997 45.8336V38.3335C20.0997 37.8735 19.7266 37.5 19.2666 37.5H13.4331ZM18.4331 45.0001H14.2663V39.1666H18.4331V45.0001Z",
    fill: "url(#paint7_linear_4872_39438)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M22.5957 33.3333C22.1353 33.3333 21.7622 33.7063 21.7622 34.1668V45.8333C21.7622 46.2933 22.1353 46.6664 22.5957 46.6664H28.4288C28.8892 46.6664 29.2623 46.2933 29.2623 45.8333V34.1664C29.2623 33.7063 28.8892 33.3333 28.4288 33.3333H22.5957ZM27.5957 44.9997H23.4289V34.9999H27.5957V44.9997Z",
    fill: "url(#paint8_linear_4872_39438)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M31.7623 27.5C31.3023 27.5 30.9292 27.8731 30.9292 28.3335V45.833C30.9292 46.2935 31.3023 46.6666 31.7623 46.6666H37.5958C38.0558 46.6666 38.4293 46.2935 38.4293 45.833V28.3335C38.4293 27.8735 38.0562 27.5004 37.5958 27.5004H31.7623V27.5ZM36.7623 44.9999H32.5958V29.1666H36.7623V44.9999Z",
    fill: "url(#paint9_linear_4872_39438)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M40.9292 15.8333C40.4688 15.8333 40.0957 16.2063 40.0957 16.6668V45.8332C40.0957 46.2932 40.4688 46.6663 40.9292 46.6663H46.7622C47.2227 46.6663 47.5957 46.2932 47.5957 45.8332V16.6668C47.5957 16.2063 47.2227 15.8333 46.7622 15.8333H40.9292ZM45.9291 44.9997H41.7623V17.4999H45.9291V44.9997Z",
    fill: "url(#paint10_linear_4872_39438)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4872_39438",
    x1: 4.05662,
    y1: 0.208983,
    x2: 49.9737,
    y2: 46.1259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437,
    stopColor: "#3873B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C9DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4872_39438",
    x1: 2.38998,
    y1: 1.87564,
    x2: 48.3068,
    y2: 47.7925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437,
    stopColor: "#3873B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C9DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4872_39438",
    x1: -0.109995,
    y1: 4.37581,
    x2: 45.8068,
    y2: 50.2927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437,
    stopColor: "#3873B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C9DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4872_39438",
    x1: -1.77664,
    y1: 6.04196,
    x2: 44.1401,
    y2: 51.9589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437,
    stopColor: "#3873B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C9DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4872_39438",
    x1: -9.90027,
    y1: 14.1672,
    x2: 36.0166,
    y2: 60.0842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437,
    stopColor: "#3873B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C9DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4872_39438",
    x1: 4.78406,
    y1: -0.520042,
    x2: 50.701,
    y2: 45.3969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437,
    stopColor: "#3873B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C9DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4872_39438",
    x1: -15.9421,
    y1: 20.2085,
    x2: 29.9749,
    y2: 66.1254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437,
    stopColor: "#3873B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C9DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4872_39438",
    x1: -10.7332,
    y1: 15.0004,
    x2: 35.1837,
    y2: 60.9174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437,
    stopColor: "#3873B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C9DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4872_39438",
    x1: -5.11244,
    y1: 9.37517,
    x2: 40.8045,
    y2: 55.2921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437,
    stopColor: "#3873B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C9DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4872_39438",
    x1: 0.929418,
    y1: 3.33377,
    x2: 46.8463,
    y2: 49.2508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437,
    stopColor: "#3873B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C9DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4872_39438",
    x1: 8.42967,
    y1: -4.1664,
    x2: 54.3466,
    y2: 41.7503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437,
    stopColor: "#3873B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C9DD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4872_39438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpReverseImage);
export default __webpack_public_path__ + "static/media/ipReverseImage.f4cf866a5b5b002fc8d4c2f817f73509.svg";
export { ForwardRef as ReactComponent };